import React from 'react';
import nextCookie from 'next-cookies';
import { get } from 'lodash';
import route from '../constants/routes';
import { USER_TOKEN_COOKIE_KEY, COOKIE_USER, ACTIVE_PROFILE_ID } from '../constants/cookieConstants';

export const nextPageQueryName = 'page';

export function makeRedirect(ctx, toUrl) {
  const { req, res } = ctx;
  const isServer = !!req;
  if (isServer) {
    const url = req.originalUrl ? `${toUrl}?${nextPageQueryName}=${encodeURIComponent(req.originalUrl)}` : toUrl;
    res.writeHead(302, {
      Location: url,
    });
    res.end();
  } else {
    const url = ctx.asPath ? `${toUrl}?${nextPageQueryName}=${ctx.asPath}` : toUrl;
    window.location.replace(url);
  }
}

export const getToken = ctx => {
  const cookies = nextCookie(ctx);
  return get(cookies, USER_TOKEN_COOKIE_KEY);
};

export const getActiveProfileIdFromCookies = ctx => {
  const cookies = nextCookie(ctx);
  return parseInt(get(cookies, ACTIVE_PROFILE_ID), 10);
};

export const getCookieUser = ctx => {
  const cookies = nextCookie(ctx);
  return get(cookies, COOKIE_USER);
};

export const auth = ctx => {
  const token = getToken(ctx);
  if (!token) {
    makeRedirect(ctx, route.LOGIN);
  }
};

export const withAuthSync = WrappedComponent => {
  const Wrapper = props => <WrappedComponent {...props} />;

  Wrapper.getInitialProps = async ctx => {
    const token = auth(ctx);
    const { store } = ctx;

    const componentProps = WrappedComponent.getInitialProps && (await WrappedComponent.getInitialProps(ctx));

    return { store, ...componentProps, token };
  };

  return Wrapper;
};
